<script setup>
import { RouterView } from 'vue-router';
import HeroSection from './components/layout/HeroSection/HeroSection.vue';
import AppFooter from './components/layout/AppFooter/AppFooter.vue';
import logoSrc from '@/assets/images/logo.png?w=125&h=125&format=webp';
import logoSrc2x from '@/assets/images/logo.png?w=250&h=250&format=webp';
</script>

<template>
    <header>
        <img
            alt="Vue logo"
            class="logo"
            :src="logoSrc"
            :srcset="logoSrc2x + ' 2x'"
            width="125"
            height="125"
            loading="lazy"
        />

        <div class="wrapper">
            <HeroSection msg="Print In A Pinch" />
        </div>
    </header>

    <RouterView />
    <AppFooter />
</template>

<style scoped>
header {
    line-height: 1.5;
    max-height: 100vh;
}

.logo {
    display: block;
    margin: 0 auto 2rem;
}

@media (min-width: 1024px) {
    header {
        display: flex;
        align-items: flex-start;
        padding-right: calc(var(--section-gap) / 2);
    }

    .logo {
        margin: 0 2rem 0 0;
    }

    header .wrapper {
        display: flex;
        place-items: flex-start;
        flex-wrap: wrap;
    }

    nav {
        text-align: left;
        margin-left: -1rem;
        font-size: 1rem;

        padding: 1rem 0;
        margin-top: 1rem;
    }
}
</style>
